// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "spa-assets/on-demand/ml-shared-ml-power-footer-module-styles") return "spa-assets/on-demand/ml-shared-ml-power-footer-module-styles-8183091b87c33794219a.m.js";
	if (chunkId === "spa-assets/js/vendors/vue-router") return "spa-assets/js/vendors/vue-router-e3bde81d90f566beb385.m.js";
	if (chunkId === "spa-assets/js/jcrs/site-ml-outage-module-specific-power-footer-section-en-power-footer-section.json") return "spa-assets/js/jcrs/site-ml-outage-module-specific-power-footer-section-en-power-footer-section-jcr-fe4274ac5df12ef769d6.m.js";
	// return url for filenames based on template
	return undefined;
};